import { render } from "./KeyboardF2.vue?vue&type=template&id=148a89cf"
import script from "./KeyboardF2.vue?vue&type=script&lang=js"
export * from "./KeyboardF2.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/KeyboardF2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "148a89cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('148a89cf', __exports__)) {
    api.reload('148a89cf', __exports__)
  }
  
  module.hot.accept("./KeyboardF2.vue?vue&type=template&id=148a89cf", () => {
    api.rerender('148a89cf', render)
  })

}


export default __exports__